import axios from 'axios'

const axiosServices = axios.create({
    baseURL: process.env.REACT_APP_API_URL || 'http://localhost:8080'
})

// 1. REQUEST INTERCEPTOR
axiosServices.interceptors.request.use(
    (config) => {
        // 👇 PRIORITY 1: Look for 'accessToken' (The correct one)
        let token = localStorage.getItem('accessToken')

        // Fallback: If not found, try 'token'
        if (!token) {
            token = localStorage.getItem('token')
        }

        if (token) {
            // Remove any extra quotes (common bug)
            const cleanToken = token.replace(/^"|"$/g, '')
            config.headers.Authorization = `Bearer ${cleanToken}`
        }

        return config
    },
    (error) => Promise.reject(error)
)

// 2. RESPONSE INTERCEPTOR
axiosServices.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {

            // Ignore the error if it came from the login endpoint
            if (error.config && error.config.url && (error.config.url.includes('/auth/authenticate') || error.config.url.includes('/auth/login'))) {
                return Promise.reject(error)
            }

            console.warn("Session expired or unauthorized. Clearing tokens.")

            // 🧹 Clear the tokens
            localStorage.removeItem('accessToken')
            localStorage.removeItem('token')
            localStorage.removeItem('user')

            // 👇 THE FIX: Check the current URL before redirecting!
            // Define paths that are allowed to fail 401s silently without redirecting
            const currentPath = window.location.pathname;
            const publicPaths = ['/', '/login', '/register', '/forgot-password', '/reset-password', '/documentation'];

            // Only force a redirect if they are NOT on a public page
            if (!publicPaths.includes(currentPath) && !currentPath.startsWith('/share/')) {
                window.location.href = '/login'
            }
        }
        return Promise.reject(error)
    }
)

export default axiosServices